import { SxProps } from '@mui/material';

export const ListItemStyles: SxProps = {
    flexDirection: 'column',
    alignItems: 'flex-start',
};

export const ListItemTextStyles: SxProps = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
};
